import { gql } from "@apollo/client";

export const FILE_UPLOAD = gql`
  mutation FileUploadModel($input: FileUploadInput) {
    fileUploadModel(input: $input) {
      label
      message
    }
  }
`;